import { AxiosResponse } from 'axios';
import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';
import { PaginatedKiloGLMRecordListList } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams, urlParamsFromUrl } from 'utils/functions';

function useKiloGLMRecords(
  kiloGlmFlowId: string | null,
): UseInfiniteQueryResult<AxiosResponse<PaginatedKiloGLMRecordListList>> {
  const fetchRecords = ({
    pageParam = { limit: '20', offset: '0' },
  }: {
    pageParam?: { limit: string; offset: string };
  }): Promise<AxiosResponse<PaginatedKiloGLMRecordListList>> => {
    return client.get(`kilo-glm-records/?kilo_glm_flow_id=${kiloGlmFlowId}&${encodeUrlParams(pageParam)}`);
  };
  return useInfiniteQuery(['kilo-glm-records', kiloGlmFlowId], fetchRecords, {
    enabled: !!kiloGlmFlowId,
    getNextPageParam: page => {
      return page.data.next ? urlParamsFromUrl(page.data.next) : undefined;
    },
  });
}

export default useKiloGLMRecords;
